import request from "@/utils/request";

export default {
    // 首页信息
    getHomeApi(params) {
        return request({
            url: "/system/index/list",
            method: "get",
            params,
            noToken: true,
        });
    },

    // 修改用户信息
    putUserInfoApi(data) {
        return request({
            url: `/system/user`,
            method: "put",
            data,
        });
    },

    // 获取我的订单列表
    getMyOrderListApi(params) {
        return request({
            url: "/system/order/list",
            method: "get",
            params,
        });
    },

    // 订单删除
    delMyOrderApi(params) {
        return request({
            url: `/system/order/delete`,
            method: "delete",
            params,
        });
    },

    // 获取合作机构(机构养老，社区/居家养老，旅居养老,定制养老)
    getAgencyListApi(params) {
        return request({
            url: "/system/server/list",
            method: "get",
            params,
            genericToken: true
        });
    },

    // 获取合作机构导航部分图片
    getAgencyNavigationListApi(params) {
        return request({
            url: "/system/navigation/list",
            method: "get",
            params,
            noToken: true
        });
    },

    // 获取合作机构  动态 图片
    getServerServeImgApi(params) {
        return request({
            url: "/system/server/serve/image",
            method: "get",
            params,
            noToken: true,
        });
    },

    // 获取机构详细信息
    getAgencyInfoApi(params) {
        return request({
            url: "/system/server/info",
            method: "get",
            params,
        });
    },

    // 获取机构测评信息
    getAgencyServerCommentInfoApi(params) {
        return request({
            url: "/system/server/serverComment/info",
            method: "get",
            params,
        });
    },

    // 获取机构交通及周边信息
    getAgencyServerTrafficInfoApi(params) {
        return request({
            url: "/system/server/serverTraffic/info",
            method: "get",
            params,
        });
    },

    // 健康管理
    getSkuListInfoApi(params) {
        return request({
            url: "/system/sku/list",
            method: "get",
            params,
        });
    },

    // 获取健康管理详情
    getSkuInfoApi(params) {
        return request({
            url: "/system/sku/info",
            method: "get",
            params,
        });
    },

    // 获取联系我们加入我们网站声明富文本
    getAboutusInfoApi(params) {
        return request({
            url: "/system/aboutus/list",
            method: "get",
            params,
            noToken: true,
        });
    },

    // 获取个人消息列表
    getMyNoticeListApi(params) {
        return request({
            url: "/system/user/notice/list",
            method: "get",
            params,
        });
    },

    // 获取右侧养老指南列表
    getRightElderlyGuideListApi(params) {
        return request({
            url: "/system/guide/list",
            method: "get",
            params,
            noToken: true,
        });
    },

    // 获取养老指南详细内容
    getGuideInfoApi(params) {
        return request({
            url: "/system/guide/info",
            method: "get",
            params,
            noToken: true,
        });
    },

    // 获取保险列表
    getInsuranceListApi(params) {
        return request({
            url: "/system/insurance/list",
            method: "get",
            params,
            noToken: true,
        });
    },

    // 获取保险详细信息
    getInsuranceInfoApi(params) {
        return request({
            url: "/system/insurance/info",
            method: "get",
            params,
            noToken: true
        });
    },

    // 获取保险保障计划详细信息
    getInsurancePlanApi(params) {
        return request({
            url: "/system/insurance/plan/info",
            method: "get",
            params,
            noToken: true
        });
    },

    // 保险使用规则
    getInsuranceRuleApi(params) {
        return request({
            url: "/system/insurance/rule/info",
            method: "get",
            params,
            noToken: true,
        });
    },

    // 获取购物车列表
    getShopCartListApi(params) {
        return request({
            url: "/system/cart/list",
            method: "get",
            params,
        });
    },

    // 获取用户收货地址
    getAddressListApi(params) {
        return request({
            url: "/system/address/list",
            method: "get",
            params,
        });
    },

    // 修改收货地址
    postAddressEditApi(data) {
        return request({
            url: `/system/address/edit`,
            method: "post",
            data,
        });
    },

    // 新增收货地址
    postAddressAddApi(data) {
        return request({
            url: `/system/address/save`,
            method: "post",
            data,
        });
    },

    // 删除收货地址
    delAddressApi(params) {
        return request({
            url: `/system/address/delete`,
            method: "delete",
            params,
        });
    },

    // 获取会员套餐列表
    getLevelListApi(params) {
        return request({
            url: "/system/level/list",
            method: "get",
            params,
            noToken: true,
        });
    },

    // 查询会员套餐详情
    getLevelInfoApi(params) {
        return request({
            url: "/system/level/info",
            method: "get",
            params,
        });
    },

    // 获取养老专题文章
    getSpecialListApi(params) {
        return request({
            url: "/system/guide/list",
            method: "get",
            params,
            noToken: true,
        });
    },

    // 输入养老评论
    postSpecialInfoApi(data) {
        return request({
            url: "/system/comment/save",
            method: "post",
            data,
        });
    },

    // 我的评论
    getMyCommentApi(params) {
        return request({
            url: "/system/comment/personal/info",
            method: "get",
            params,
        });
    },

    // 机构入驻申请单
    postMechanismSaveApi(data) {
        return request({
            url: "/system/mechanism/save",
            method: "post",
            data,
            noToken: true,
        });
    },

    // 获取机构列表
    getMechanismListApi(params) {
        return request({
            url: "/system/mechanism/list",
            method: "get",
            params,
            noToken: true
        });
    },

    // 新增订单
    postOrderSaveApi(data) {
        return request({
            url: `/system/order/save`,
            method: "post",
            data,
        });
    },

    // 新增报价信息
    postOfferSaveApi(data) {
        return request({
            url: `/system/offer/save`,
            method: "post",
            data,
        });
    },

    // 新增参观信息
    postVisitSaveApi(data) {
        return request({
            url: `/system/visit/save`,
            method: "post",
            data,
        });
    },

    // 获取养老服务内容
    getServerContentInfoApi(params) {
        return request({
            url: "/system/server/serverContent/info",
            method: "get",
            params,
        });
    },

    // 获取养老服务配置设施
    getServerConfigInfoApi(params) {
        return request({
            url: "/system/server/serverConfig/info",
            method: "get",
            params,
            noToken: true,
        });
    },

    // 添加至购物车
    postCartSaveApi(data) {
        return request({
            url: `/system/cart/save`,
            method: "post",
            data,
        });
    },

    // 删除购物车
    delCartApi(params) {
        return request({
            url: `/system/cart/delete`,
            method: "delete",
            params,
        });
    },

    // 获取机构测评详情
    getAgencyCommentInfoApi(params) {
        return request({
            url: "/system/server/serverComment/info",
            method: "get",
            params,
        });
    },

    // 设置默认地址
    getAddressDefaultApi(params) {
        return request({
            url: "/system/address/default",
            method: "get",
            params,
        });
    },

    // 支付宝支付接口
    postPayAliApi(data) {
        return request({
            url: `/system/payment/ali`,
            method: "post",
            data,
        });
    },

    postPayWXApi(data) {
        return request({
            url: `/system/payment/native/generate/order`,
            method: "post",
            data,
        });
    },


    postPayWXTwoApi(data) {
        return request({
            url: `/system/payment/native/generate/orderTwo`,
            method: "post",
            data,
        });
    },

    // 查询微信支付成功接口
    getWXPayStatusApi(params) {
        return request({
            url: "/system/payment/get/order",
            method: "get",
            params,
        });
    },

    // 支付宝查询支付成功接口
    getAliPayStatusApi(params) {
        return request({
            url: "/system/payment/ali/query/order",
            method: "get",
            params,
        });
    },

    // 获取订单详细信息
    getOrderInfoApi(params) {
        return request({
            url: "/system/order/info",
            method: "get",
            params,
        });
    },

    // 新增试住预约信息
    postSaveLiveApi(data) {
        return request({
            url: `/system/server/save/live`,
            method: "post",
            data,
        });
    },

    // 获取省
    getProvinceListApi(params) {
        return request({
            url: "/system/bsProvince/list/all",
            method: "get",
            params,
        });
    },

    // 获取市
    getBsCityListApi(params) {
        return request({
            url: "/system/bsCity/list/all",
            method: "get",
            params,
            noToken: true,
        });
    },

    // 获取区
    getBsAreaListApi(params) {
        return request({
            url: "/system/bsArea/list/all",
            method: "get",
            params,
            noToken: true,
        });
    },

    // 新增意见反馈
    postIdeaApi(data) {
        return request({
            url: `/system/idea/save`,
            method: "post",
            data,
            noToken: true,
        });
    },

    // 修改密码
    putProfileUpdatePwdApi(params) {
        return request({
            url: `/system/user/profile/updatePwd`,
            method: "put",
            params,
        });
    },

    // 获取会员首页套餐
    getLevelHomeApi(params) {
        return request({
            url: "/system/level/home",
            method: "get",
            params,
            noToken: true
        });
    },

    // 获取论坛首页轮播
    getSwiperHomeApi(params) {
        return request({
            url: "/system/guide/home",
            method: "get",
            params,
            noToken: true,
        });
    },

    // 定制养老方案
    addMade(data) {
        return request({
            url: "/system/made/save",
            method: "post",
            data,
        });
    },

    // 获取字典数据
    getDictData(type) {
        return request({
            url: "/system/dict/data/type/" + type,
            method: "get",
            noToken: true
        });
    },

    /**
     * 发送短信验证码
     */
    getSmsCode(params) {
        // params.phonenumber  手机号
        // params.source 1 登录 2 注册 3 机构入驻  4 预约参观 5 获取报价
        return request({
            url: "/system/user/getCode",
            method: "get",
            params,
            noToken: true
        });
    },

    /**
     * 获取最新的用户协议||隐私政策||入驻协议
     */
    getProtocolInfo(params) {
        // params.type  1 用户协议 2 隐私政策 3 软件协议
        return request({
            url: "/system/user/covenant",
            method: "get",
            params,
            noToken: true,
        });
    },

    /**
     * 用户注册
     */
    userRegister(data) {
        return request({
            url: "/system/user/register",
            method: "post",
            data,
        });
    },

    /**
     * 在线预约表单提交
     */
    saveBooking(data) {
        return request({
            url: "/system/booking/save",
            method: "post",
            data,
        });
    },

    getServerType(params) {
        return request({
            url: "/system/server/types",
            method: "get",
            params,
            noToken: true
        });
    },

    getServerTypeAll(params) {
        return request({
            url: "/system/server/all",
            method: "get",
            params,
            noToken: true
        });
    },

    /**
     * 保存订单的在线预约
     */
    savePrebook(data) {
        return request({
            url: "/system/prebook/save",
            method: "post",
            data,
        });
    },

    /**
     * 获取订单详情
     */
    getOrderDetail(params) {
        return request({
            url: "/system/order/detail",
            method: "get",
            params,
        });
    },

    /**
     * 合作机构下单
     */
    saveOrder(data) {
        return request({
            url: "/system/order/save",
            method: "post",
            data,
        });
    },

    updateAddress(data) {
        return request({
            url: "/system/order/harvest/address/add",
            method: "post",
            data,
        });
    },

    getOrderCodeInfo(params) {
        return request({
            url: "/system/order/code/info",
            method: "get",
            params,
        });
    },

    getCheckupRecode(params) {
        return request({
            url: "/system/checkup/recode/all",
            method: "get",
            params,
        });
    },

    /**
     * 获取活动讲座列表
     */
    getActivityAll(params) {
        return request({
            url: "/system/activity/home/list",
            method: "get",
            params,
            noToken: true,
        });
    },

    /**
     * 活动讲座详情
     */
    getActivityDetail(params) {
        return request({
            url: "/system/activity/info",
            method: "get",
            params,
        });
    },

    /**
     * 添加活动记录
     */
    addActivity(data) {
        return request({
            url: "/system/activity/record/save",
            method: "post",
            data,
        });
    },

    /**
     * 我的权益-当前会员套餐的权益
     */
    getPowerList() {
        return request({
            url: "/system/record/power/list",
            method: "get",
        });
    },

    /**
     * 获取帮助数量
     */
    getHelpCount() {
        return request({
            url: "/system/index/helped",
            method: "get",
            noToken: true
        });
    },
};
